import { Text } from '@lmn/design-system';
import styled from 'styled-components';

export const StrikeThroughPrice = styled(Text).attrs({ variant: 'BodySmall' })`
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  text-decoration: line-through;
  text-decoration-thickness: 1px;
  text-decoration-color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
`;
